import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Memo',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Memo',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Memo',
    column_type: 'datetime',
  },
  content: {
    model_name: 'Memo',
    column_type: 'string',
  },
  remind_at: {
    model_name: 'Memo',
    column_type: 'datetime',
  },
  customer: {
    model_name: 'Memo',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer',
      model_name: 'Customer',
    },
  },
  customer_id: {
    model_name: 'Memo',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer',
      model_name: 'Customer',
    },
  },
  is_reminded: {
    model_name: 'Memo',
    column_type: 'boolean',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
